import { Instagram, Youtube, Facebook } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { CHURCH, NAV } from "@/lib/data";

export default function Footer() {
  const year = new Date().getFullYear();
  const { pathname } = useLocation();
  const onHome = pathname === "/";
  const buildHref = (href) => (onHome ? href : `/${href}`);
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#020202] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <span className="w-12 h-12 flex items-center justify-center bg-white/95 rounded-full overflow-hidden shrink-0">
                <img
                  src="/logo-pibg.png"
                  alt="Logo PIBG"
                  className="w-full h-full object-contain p-1"
                />
              </span>
              <p className="font-serif-display text-3xl text-white">
                PIB<span className="text-[#D4AF37]">G</span>
              </p>
            </div>
            <p className="mt-4 text-white/55 text-sm leading-relaxed max-w-sm">
              {CHURCH.name} — uma família brasileira em Greenville, SC, fiel à
              Palavra de Deus desde {CHURCH.founded}.
            </p>

            <div className="mt-8 flex items-center gap-3">
              <a
                href={CHURCH.socials.instagram.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-social-instagram"
                className="w-10 h-10 border border-white/10 flex items-center justify-center text-white/65 hover:text-[#D4AF37] hover:border-[#D4AF37] transition-all"
              >
                <Instagram size={16} strokeWidth={1.5} />
              </a>
              <a
                href={CHURCH.socials.youtube.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                data-testid="footer-social-youtube"
                className="w-10 h-10 border border-white/10 flex items-center justify-center text-white/65 hover:text-[#D4AF37] hover:border-[#D4AF37] transition-all"
              >
                <Youtube size={16} strokeWidth={1.5} />
              </a>
              <a
                href={CHURCH.socials.facebook.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                data-testid="footer-social-facebook"
                className="w-10 h-10 border border-white/10 flex items-center justify-center text-white/65 hover:text-[#D4AF37] hover:border-[#D4AF37] transition-all"
              >
                <Facebook size={16} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] tracking-overline uppercase text-[#D4AF37] mb-5">
              Navegação
            </p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <Link
                    to={buildHref(n.href)}
                    className="text-white/65 hover:text-white transition-colors text-sm"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[10px] tracking-overline uppercase text-[#D4AF37] mb-5">
              Contato
            </p>
            <address className="not-italic space-y-3 text-sm text-white/65">
              <p>{CHURCH.address}</p>
              <p>
                <a
                  href={`tel:${CHURCH.phoneRaw}`}
                  className="hover:text-white transition-colors"
                >
                  {CHURCH.phone}
                </a>
              </p>
              <p>
                <a
                  href={`mailto:${CHURCH.email}`}
                  className="hover:text-white transition-colors"
                >
                  {CHURCH.email}
                </a>
              </p>
            </address>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between text-xs text-white/40">
          <p>
            © {year} {CHURCH.name}. Todos os direitos reservados.
          </p>
          <p className="tracking-overline uppercase">
            Feito com fé · Greenville, SC
          </p>
        </div>
      </div>
    </footer>
  );
}
